import { axios } from '@/axios.config';

export const state = {
  data: [],
};

export const actions = {
  fetchIdentityProviders: async ({ commit }) => {
    try {
      const res = await axios.get('/idp/');
      commit('updateIdentityProviders', res.data.data);
    } catch (e) {
      console.error(e);
      commit('updateIdentityProviders', []);
    }
  },
  saveIdentityProviders: async ({ dispatch }, { id, formData }) => {
    try {
      if (id) {
        await axios.put(`/idp/${id}`, formData);
      } else {
        await axios.post('/idp/', formData);
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
    await dispatch('fetchIdentityProviders');
  },
  deleteIdentityProviders: async ({ dispatch }, { id }) => {
    try {
      await axios.delete(`/idp/${id}`);
    } catch (e) {
      console.log(e);
      throw e;
    }
    await dispatch('fetchIdentityProviders');
  },
};

export const mutations = {
  updateIdentityProviders(state, data) {
    state.data = data;
  },
};

export const getters = {
  identityProviders(state) {
    return state.data;
  },
};
